
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "revenuemodel",
  "title": "Revenue Model",
  "sidebar_label": "Revenue Model"
};
const slug = 'revenuemodel';
const tableOfContents = [{
  "title": "100% Transfer",
  "slug": "100-transfer",
  "children": []
}, {
  "title": "% Commission/Fee",
  "slug": "commission-fee",
  "children": [{
    "title": "Video: Configuring Revenue Model",
    "slug": "video-configuring-revenue-model",
    "children": []
  }]
}, {
  "title": "Subscription Model",
  "slug": "subscription-model",
  "children": []
}, {
  "title": "Special Fees",
  "slug": "special-fees",
  "children": []
}, {
  "title": "Classified style featured ads",
  "slug": "classified-style-featured-ads",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p>{`Based on your company strategy, you can opt for different revenue models. Below are the list which are available and roadmap as well`}</p>
    <_Heading level={2} id={"100-transfer"} nextElement={{
      "type": "paragraph"
    }}>100% Transfer</_Heading>
    <p>{`Applicable for Stripe Standard
Available for clients based in Stripe connect supported countries. `}</p>
    <_Heading level={2} id={"commission-fee"} nextElement={{
      "type": "paragraph"
    }}>% Commission/Fee</_Heading>
    <p>{`AVAILABLE`}</p>
    <pre><code parentName="pre" {...{}}>{`- SupplySide only with category 
- Demand Side only with category 
- Supply and Demand 
- Custom conditions conditions like country, category, accounts (On Roadmap)
`}</code></pre>
    <p>{`Available for clients based in stripe connected supported countries. Here is how it works. `}</p>
    <img src="/img/tradly-commission-model1.png" alt="commission-revenue" width="800" />
    <_Heading level={3} id={"video-configuring-revenue-model"} nextElement={{
      "type": "jsx"
    }}>Video: Configuring Revenue Model</_Heading>
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/zyVf4t5U_GE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"subscription-model"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Subscription Model</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`You can charge for accounts to allow them posting listings. Once they pay, the system will allow them to post listings. `}</p>
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Paid Listings with no of listings controlled (For first 5 free, after that charges) `}</li>
          <li parentName="ul">{`Paid Listing  for first listing itself`}</li>
          <li parentName="ul">{`Paid Listing Package (5 listings - $10, 20 Listings -$20) `}</li>
          <li parentName="ul">{`Pay you as Go (Pay per listings) `}</li>
          <li parentName="ul">{`Listing Monthly Subscription `}</li>
        </ul>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://superadmin.tradly.app/subscription"
      }}>{`Visit SuperAdmin`}</a></p>
    <_Heading level={2} id={"special-fees"} nextElement={{
      "type": "jsx"
    }}>Special Fees</_Heading>
    <div class="relative">
      <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/special-fees.png" alt="Special fees" />
    </div>
    <p><a parentName="p" {...{
        "href": "https://superadmin.tradly.app/special-fees"
      }}>{`Visit SuperAdmin`}</a></p>
    <_Heading level={2} id={"classified-style-featured-ads"} nextElement={{
      "type": "paragraph"
    }}>Classified style featured ads</_Heading>
    <p>{`Using Promotions, you can do paid banners. Available on home page and possibility in other pages. And it is possible for all countries with Stripe Payments or other
`}<a parentName="p" {...{
        "href": "https://tradly.app/docs/paymentgateways"
      }}>{`custom payments method mentioned here`}</a></p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
